import { render, staticRenderFns } from "./PrestazionePerFamiliare.vue?vue&type=template&id=507306c8&"
import script from "./PrestazionePerFamiliare.vue?vue&type=script&lang=js&"
export * from "./PrestazionePerFamiliare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports